var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoCircular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294 294"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".logo_circular_svg__cls-2{fill:#24292e}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_circular_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_circular_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 147,
    r: 147,
    fill: "#f6f8fa"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_circular_svg__cls-2",
    d: "M181.94 184.72c-7.82 0-13.05 5.89-13.05 15.56s3.88 19.64 13.05 19.46c9.64-.2 13.12-8.65 13-19.46-.03-9.67-5.21-15.56-13-15.56zm49-46.44c1.19-5.23 1.7-23.75-6.88-43.07 0 0-19.7 1.93-49.49 20.23-6.23-1.55-16.81-2.32-27.38-2.32s-21.12.77-27.39 2.31C90 97.14 70.3 95.21 70.3 95.21c-8.59 19.32-8.17 37.4-6.89 43.07-10.09 9.8-16.26 21.57-16.26 37.65 0 69.91 64.81 71 81.17 71H166c16.35 0 81.16-1.13 81.16-71-.01-16.08-6.16-27.85-16.26-37.65zM147.77 239.2h-.62c-41 0-73.23-5.22-73.23-40.88 0-8.54 3.38-16.46 11.38-23 13.35-11 35.92-5.17 61.55-5.17h.61c25.63 0 48.22-5.79 61.57 5.17 8 6.58 11.36 14.5 11.36 23 0 35.68-31.63 40.88-72.62 40.88zm-35.4-54.48c-7.79 0-13 7.84-13 17.51s5.25 17.51 13 17.51 13-7.84 13-17.51-5.19-17.51-13-17.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_circular_svg__cls-2",
    d: "M179.92 102.39c-3.95-11-8.8-16.09-11.61-18.29a1.27 1.27 0 00-2.08.93c.82 11.83-4.15 14.84-7 8.07-1.13-2.71-1.79-7.38-1.79-13.08a41.66 41.66 0 00-9.85-27.17 32.79 32.79 0 00-6.19-5.63 1.26 1.26 0 00-2 1c.52 6.43 0 24.85-18 46.85-16.37 20.41-10 36.09-7.77 40.34a35.11 35.11 0 0016.17 15.7c1.13.54 2.33-.63 1.64-1.6a26.46 26.46 0 01-1.58-2.48h33.36a20.81 20.81 0 01-1.38 2.32c-.66 1 .51 2.11 1.64 1.59a39.54 39.54 0 006.72-3.94h1.8v-1.42c5.7-4.76 10.44-11.94 11.19-22.78.41-4.9-.19-11.75-3.27-20.41z"
  })))));
}

export default SvgLogoCircular;